module.exports = __webpack_public_path__ + "img/symbol_12.7483c74b.png";